/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import { HttpParams } from "@angular/common/http";
import { isNullOrUndefined } from "../../../utils";
import {
	CREATE_NEW_SCENARIO_RESPONSE,
	GET_SCENARIO_INFO_RESPONSE,
	DELETE_SCENARIO_RESPONSE,
	GET_SCENARIO_SIMULATION_STATUS_RESPONSE
} from "./what-if-scenario.db";
import { ApplicationError } from "../../../../models/ui/application-error.model";

export class WhatIfScenario {
	public static createNewScenario(options: HttpRequestOptions) {
		const { params, pathParams } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.createNewScenario.name
					)
			);

		const startingScenario = httpParams.get("startingScenario");
		const tenantId = httpParams.get("tenantId");

		if (!startingScenario || !tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						this.constructor.name,
						this.createNewScenario.name
					)
			);

		const appId = pathParams?.["appId"];

		if (!appId)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required path parameter",
						this.constructor.name,
						this.createNewScenario.name
					)
			);

		return of(CREATE_NEW_SCENARIO_RESPONSE);
	}

	public static getScenarioInfo(options: HttpRequestOptions) {
		const { params, pathParams } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.getScenarioInfo.name
					)
			);

		const tenantId = httpParams.get("tenantId");

		if (!tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"No tenant token provided",
						this.constructor.name,
						this.getScenarioInfo.name
					)
			);

		const appId = pathParams?.["appId"];
		const scenarioId = pathParams?.["scenarioId"];

		if (!appId || isNullOrUndefined(scenarioId))
			return throwError(
				() =>
					new ApplicationError(
						"Missing required path parameters",
						this.constructor.name,
						this.getScenarioInfo.name
					)
			);

		return of(GET_SCENARIO_INFO_RESPONSE[+scenarioId!]);
	}

	public static deleteScenario(options: HttpRequestOptions) {
		const { params, pathParams } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.deleteScenario.name
					)
			);

		const tenantId = httpParams.get("tenantId");

		if (!tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"No tenant token provided",
						this.constructor.name,
						this.deleteScenario.name
					)
			);

		const appId = pathParams?.["appId"];
		const scenarioId = pathParams?.["scenarioId"];

		if (!appId || isNullOrUndefined(scenarioId))
			return throwError(
				() =>
					new ApplicationError(
						"Missing required path parameters",
						this.constructor.name,
						this.deleteScenario.name
					)
			);

		return of(DELETE_SCENARIO_RESPONSE);
	}

	public static getScenarioSimulationStatus(options: HttpRequestOptions) {
		const { params, pathParams } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.getScenarioSimulationStatus.name
					)
			);

		const tenantId = httpParams.get("tenantId");

		if (!tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"No tenant token provided",
						this.constructor.name,
						this.getScenarioSimulationStatus.name
					)
			);

		const appId = pathParams?.["appId"];
		const scenarioId = pathParams?.["scenarioId"];

		if (!appId || isNullOrUndefined(scenarioId))
			return throwError(
				() =>
					new ApplicationError(
						"Missing required path parameters",
						this.constructor.name,
						this.getScenarioSimulationStatus.name
					)
			);

		return of(GET_SCENARIO_SIMULATION_STATUS_RESPONSE);
	}
}
